import {catchError, map, exhaustMap, share, mergeMap, withLatestFrom} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { BackendService } from '../../services/backend/backend.service';
import { AppState } from '../../interfaces/app-state.interface';
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { RoutesTable } from '../../resources/routes-table.model';
import { BillingAction } from './billing.action';

@Injectable()
export class BillingEffects {

    /**
     * Obtém dados da taxa de negociação.
     */
    public getBrokerageTax$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(BillingAction.getBrokerageTax),
                withLatestFrom(this.store$.select((store) => store.billing)),
                mergeMap(([action, billingState]) => {

                    const normalizedSymbol = action.payload.symbol.toUpperCase();

                    const url = RoutesTable.composeUri(
                        RoutesTable.billing.routes.getBrokerageTax,
                        action.payload.isDaytrade,
                        action.payload.orderQty,
                        action.payload.platform,
                        action.payload.price, normalizedSymbol
                    );

                    // Checking on server
                    return this.dataService
                        .get<DefaultResponse>(url)
                        .pipe(
                            map((result: any) => {

                                if (!result.ok || !result.value) {
                                    return {type: BillingAction.getBrokerageTaxError, payload: result.messages};
                                }

                                return {type: BillingAction.getBrokerageTaxSuccess, payload: result.value};
                            }),
                            catchError(
                                (error) => of({ type: BillingAction.getBrokerageTaxError, payload: error})
                            ),
                        );
                }),
                share(),
            )
    );

    /**
     * Obtém dados da apuração mensal.
     */
    public getLastMonthlyScore$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(BillingAction.getLastMonthlyScore),
                withLatestFrom(this.store$.select((store) => store.billing)),
                exhaustMap(([action , billing]) => {

                    if (billing.monthlyScore) return of({type: BillingAction.getLastMonthlyScoreSuccess, payload: billing.monthlyScore});

                    const url = RoutesTable.billing.routes.getLastMonthlyScore.uri;

                    // Checking on server
                    return this.dataService.get<DefaultResponse>(url)
                        .pipe(
                            map((result: any) => {

                                if (!result.ok ) {
                                    return {type: BillingAction.getLastMonthlyScoreError, payload: result.messages};
                                }

                                return {type: BillingAction.getLastMonthlyScoreSuccess, payload: result.value};
                            }),
                            catchError(
                                (error) => of({ type: BillingAction.getLastMonthlyScoreError, payload: error})
                            ),
                        );
                }),
                share(),
            )
    );

    /**
     * ??
     */
    public getBrokerageModel$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(BillingAction.getBrokerageModel),
                mergeMap((action) => {

                    const url = RoutesTable.composeUri(
                        RoutesTable.billing.routes.getBrokerageModel
                    );

                    return this.dataService
                        .get<DefaultResponse>(url)
                        .pipe(
                            map((res) => {

                                if (!res.ok || !res.value) {
                                    return {type: BillingAction.getBrokerageModelError, payload: res.messages};
                                }

                                return {type: BillingAction.getBrokerageModelSuccess, payload: res.value};
                            }),
                            catchError(
                                (error) => of({ type: BillingAction.getBrokerageModelError, payload: error})
                            ),
                        );
                }),
                share(),
            )
    );

    /**
     * ??
     */
    public setBrokerageModel$ = createEffect(() =>
        this.actions$
            .pipe(
                ofType(BillingAction.setBrokerageModel),
                mergeMap((action: any) => {

                    const url = RoutesTable.composeUri(
                        RoutesTable.billing.routes.setBrokerageModel,
                        action.payload.modelName
                    );

                    return this.dataService
                        .post<DefaultResponse>(url, null)
                        .pipe(
                            map((res) => {

                                if (!res.ok || !res.value) {
                                    return {type: BillingAction.setBrokerageModelError, payload: res.messages};
                                }

                                return {type: BillingAction.setBrokerageModelSuccess, payload: res.value};
                            }),
                            catchError(
                                (error) => of({type: BillingAction.setBrokerageModelError, payload: error})
                            ),
                        );
                }),
                share()
            )
    );

    constructor(
      private actions$: Actions<BillingAction>,
      private dataService: BackendService,
      private store$: Store<AppState>,
    ) {}
}